import { Paper, Typography } from '@mui/material'

export interface moveCardInterface {
  title: string
  subtitles: string[]
}

function InformationCard({ card }: { card: moveCardInterface }) {
  return (
    <Paper
      variant={'outlined'}
      sx={{
        width: 1,
        p: 1,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography variant="subtitle2">{card.title}</Typography>
      {card.subtitles.map((item) => (
        <Typography
          variant="body2"
          key={item}
        >
          {item}
        </Typography>
      ))}
    </Paper>
  )
}

export default InformationCard
